import { render, staticRenderFns } from "./upload-new.vue?vue&type=template&id=7602a96c&"
import script from "./upload-new.vue?vue&type=script&lang=js&"
export * from "./upload-new.vue?vue&type=script&lang=js&"
import style0 from "./upload-new.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "upload-new.vue"
export default component.exports